export var PhotoCaptureImageDescription;
(function (PhotoCaptureImageDescription) {
    PhotoCaptureImageDescription["VEHICLE_IDENTIFICATION"] = "VehicleIdentificationImage";
    PhotoCaptureImageDescription["VEHICLE_MILEAGE"] = "InstrumentPanelImage";
    PhotoCaptureImageDescription["LICENSE_PLATE"] = "LicensePlateImage";
    PhotoCaptureImageDescription["VEHICLE_VIN_STICKER"] = "VehicleStickerImage";
    PhotoCaptureImageDescription["WIDE_SHOT"] = "WideShotImage";
    PhotoCaptureImageDescription["TOP_CLOSEUP"] = "TopCloseupImage";
    PhotoCaptureImageDescription["CENTER_CLOSEUP"] = "CenterCloseupImage";
    PhotoCaptureImageDescription["BOTTOM_CLOSEUP"] = "BottomCloseupImage";
    PhotoCaptureImageDescription["TOP_LEFT_CORNER"] = "FrtLeftCornerDamage";
    PhotoCaptureImageDescription["TOP_RIGHT_CORNER"] = "FrtRightCornerDamage";
    PhotoCaptureImageDescription["BOTTOM_LEFT_CORNER"] = "RearLeftCornerDamage";
    PhotoCaptureImageDescription["BOTTOM_RIGHT_CORNER"] = "RearRightCornerDamage";
    PhotoCaptureImageDescription["WALK_AROUND_VIDEO"] = "WalkAroundVideo";
    PhotoCaptureImageDescription["PHOTO_DESCRIPTION"] = "DamagePhoto";
    PhotoCaptureImageDescription["DOCUMENT_DESCRIPTION"] = "AdditionalDocument";
    PhotoCaptureImageDescription["WIDE_ENHANCED"] = "WideShotGroupDamage";
    PhotoCaptureImageDescription["WIDE_ENHANCED_ADDITIONAL"] = "WideShotGroupAdditional";
    PhotoCaptureImageDescription["DAMAGE_PANEL"] = "DamagePanel";
    PhotoCaptureImageDescription["CLOSEUP_ENHANCED"] = "CloseUpGroupDamage";
    PhotoCaptureImageDescription["CLOSEUP_ENHANCED_ADDITIONAL"] = "CloseUpGroupAdditional";
    PhotoCaptureImageDescription["SUMMARY"] = "Summary";
})(PhotoCaptureImageDescription || (PhotoCaptureImageDescription = {}));
//# sourceMappingURL=PhotoCaptureImageDescription.js.map